import { sortComponent } from './vue-extension.js'

export function mixChild(key, options = {}) {
  const indexKey = options.indexKey || 'index'

  return {
    inject: {
      [key]: {
        default: null
      }
    },
    computed: {
      parent() {
        if (this.disableBindingRelation) {
          return null
        }
        return this[key]
      },
      [indexKey]() {
        this.bindRelation()
        if (this.parent) {
          return this.parent.children.indexOf(this)
        }
        return null
      },
      isLast() {
        if (this.parent) {
          return this[indexKey] === this.parent.children.length - 1
        }
        return false
      },
      isFirst() {
        if (this.parent) {
          return this[indexKey] === 0
        }
        return false
      }
    },
    watch: {
      disableBindingRelation(val) {
        if (!val) {
          this.bindRelation()
        }
      }
    },
    mounted() {
      this.bindRelation()
    },
    beforeDestroy() {
      if (this.parent) {
        this.parent.children = this.parent.children.filter(x => x !== this)
      }
    },
    methods: {
      bindRelation() {
        if (!this.parent || this.parent.children.indexOf(this) !== -1) {
          return
        }
        this.parent.children = sortComponent([...this.parent.children, this], this.parent)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/utils/mix-child.js